export default "__VITE_ASSET__FMsnPQvP__"